const getHost = (env) => {
  switch (env) {
    case 'develop':
    case 'local':
    case 'staging-2':
    case 'staging-4':
      return 'https://hr-staging-4.workstream.us';
    case 'trunk':
      return 'https://hr-trunk.workstream.us';
    case 'staging':
      return 'https://hr-staging.workstream.us';
    case 'production':
      return 'https://hr.workstream.us';
    default:
      return 'https://hr-staging-4.workstream.us';
  }
};

const onboardingFormApp = 'onboarding-form-app';

export const getW4Entry = (env) => ({
  v0: `${getHost(env)}/s/${onboardingFormApp}/shared/w4-v0/index.html`,
  v2: `${getHost(env)}/s/${onboardingFormApp}/shared/w4-v2/index.html`,
});

export const getStateTaxEntry = (env) => ({
  v0: `${getHost(env)}/s/${onboardingFormApp}/shared/state-tax-withholding-v0/index.html`,
  v2: `${getHost(env)}/s/${onboardingFormApp}/shared/state-tax-withholding-v2/index.html`,
});

export default {
  getW4Entry,
  getStateTaxEntry,
};
